import apiClient from '../api'

/**
 * Get Deposit Plan Settings
 * @returns {Promise} Deposit plan settings including interest rate, min/max amounts, etc.
 */
export const getDepositSettings = () => {
  return apiClient.get('/deposit-plans/settings')
}

/**
 * Get period info (next period start, previous period profit)
 * @returns {Promise} next_period_start, previous_period_profit, previous_period_deposits_count
 */
export const getPeriodInfo = () => {
  return apiClient.get('/deposit-plans/period-info')
}

/**
 * Calculate Interest for Deposit Plan
 * @param {string} amount - Deposit amount
 * @param {number} durationDays - Duration in days
 * @returns {Promise} Calculated interest details
 */
export const calculateInterest = (amount, durationDays) => {
  return apiClient.post('/deposit-plans/calculate', {
    amount: amount.toString(),
    duration_days: durationDays
  })
}

/**
 * Create a new deposit plan request
 * @param {string} walletType - Wallet type (e.g., 'usdt-main')
 * @param {string} amount - Deposit amount
 * @param {number} durationDays - Duration in days
 * @returns {Promise} Created deposit plan
 */
export const createDeposit = (walletType, amount, durationDays) => {
  return apiClient.post('/deposit-plans/create', {
    wallet_type: walletType,
    amount: amount.toString(),
    duration_days: durationDays
  })
}

/**
 * Confirm deposit plan with security code
 * @param {number} depositId - Deposit plan ID
 * @param {string} securityCode - Security code (permanent key or OTP)
 * @returns {Promise} Confirmed deposit plan
 */
export const confirmDeposit = (depositId, securityCode) => {
  return apiClient.post(`/deposit-plans/${depositId}/confirm`, {
    security_code: securityCode
  })
}

/**
 * Get user's deposit plans
 * @param {string} status - Filter by status (pending, active, completed, cancelled)
 * @param {number} perPage - Items per page
 * @param {number} page - Page number
 * @returns {Promise} List of user's deposit plans
 */
export const getMyDeposits = (status = null, perPage = 15, page = 1) => {
  const params = { per_page: perPage, page: page }
  if (status) {
    params.status = status
  }
  return apiClient.get('/deposit-plans', { params })
}

/**
 * Get specific deposit plan details
 * @param {number} depositId - Deposit plan ID
 * @returns {Promise} Deposit plan details
 */
export const getDepositDetails = (depositId) => {
  return apiClient.get(`/deposit-plans/${depositId}`)
}

/**
 * Cancel an active deposit before maturity without profit
 * @param {number} depositId - Deposit plan ID
 * @param {string} securityCode - Transaction password / security code
 * @returns {Promise} Closed deposit plan
 */
export const closeDeposit = (depositId, securityCode) => {
  return apiClient.post(`/deposit-plans/${depositId}/close`, {
    security_code: securityCode
  })
}
